import {SSEDataAdapter} from "./SSEDataAdapter.js";

export class DefaultSSEDataAdapter extends SSEDataAdapter {
    public on_success_msg(data: string): void {



    }
    public on_error_msg(data: string): void {



    }

}